
import { Component, Vue } from 'vue-property-decorator';
import { beforeUpdateAndEnter } from '~/guards/SupportPanelGuard';
import { OrderModule } from '~/store/modules/order';
import OrderCard from '~/components/OrderCard.vue';

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
]);

@Component({
    components: {
        OrderCard,
    }
})
export default class OrderPanel extends Vue {

    async beforeRouteEnter(to: any, from: any, next: any) {
        await beforeUpdateAndEnter(to, from, next);
    }
    async beforeRouteUpdate(to: any, from: any, next: any) {
        await beforeUpdateAndEnter(to, from, next);
    }
    get order() {
        return OrderModule.order;
    }
    get orderId() {
        return OrderModule.orderId;
    }
}
